export default __webpack_public_path__ + "static/media/ed2mit03practice01-dsaf-work-environ-prep-v01.pptx.7cbabfef.pdf";